import { mockInventory } from '../data/mockData';

const STORAGE_KEY = 'safeguardpro_inventory_v1';

const normalizeAssignment = (item) => {
  if (!item.checkedOutBy) return [];
  return [
    {
      id: `assign-${item.id}`,
      assignedToType: item.checkedOutByType || 'student',
      assignedToId: item.checkedOutById || item.checkedOutBy || '',
      assignedToName: item.checkedOutByName || item.checkedOutBy || '',
      checkoutDate: item.checkedOutAt || new Date().toISOString().slice(0, 10),
      dueDate: item.dueDate || null,
      expectedReturnDate: item.dueDate || null,
      checkinDate: null,
      notes: ''
    }
  ];
};

const normalizeItem = (item) => {
  const statusMap = {
    maintenance: 'under_repair',
    checked_out: 'checked_out',
    available: 'available'
  };
  const typeMap = {
    Electronics: 'Tech Equipment',
    Sports: 'Sports Equipment',
    Safety: 'Learning Materials',
    Creative: 'Learning Materials'
  };

  return {
    id: item.id,
    reference: item.reference || item.itemRef || `INV-${Math.floor(Math.random() * 9000 + 1000)}`,
    name: item.name,
    type: item.type || typeMap[item.category] || 'Other',
    serialNumber: item.serialNumber || '',
    imei: item.imei || '',
    description: item.description || '',
    condition: item.condition || 'Good',
    conditionNotes: item.conditionNotes || '',
    notes: item.notes || '',
    status: statusMap[item.status] || item.status || 'available',
    assignments: item.assignments || normalizeAssignment(item),
    images: item.images || [],
    invoiceFile: item.invoiceFile || null,
    purchaseDate: item.purchaseDate || '',
    purchaseCost: item.purchaseCost || '',
    warrantyExpiry: item.warrantyExpiry || '',
    location: item.location || '',
    serviceContact: item.serviceContact || {
      name: '',
      phone: '',
      email: '',
      url: ''
    },
    safeguardingRelevant: Boolean(item.safeguardingRelevant),
    loanable: Boolean(item.loanable),
    addedBy: item.addedBy || item.createdBy || '',
    notesLog: item.notesLog || [],
    createdAt: item.createdAt || new Date().toISOString(),
    updatedAt: item.updatedAt || new Date().toISOString()
  };
};

export default class InventoryRepository {
  constructor() {
    this.cache = null;
  }

  load() {
    if (this.cache) return this.cache;
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (stored) {
      this.cache = JSON.parse(stored).map(normalizeItem);
    } else {
      this.cache = mockInventory.map(normalizeItem);
      this.persist();
    }
    return this.cache;
  }

  persist() {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.cache));
  }

  getAll() {
    return [...this.load()];
  }

  getById(id) {
    return this.load().find((item) => item.id === id) || null;
  }

  create(item) {
    this.cache = this.load();
    this.cache = [item, ...this.cache];
    this.persist();
    return item;
  }

  update(id, updated) {
    this.cache = this.load();
    this.cache = this.cache.map((item) => (item.id === id ? updated : item));
    this.persist();
    return updated;
  }
}
